module.exports = __webpack_public_path__ + "img/header-weddingRingsGayLesbianCouples.9cafba6.webp";